// Split out of mockServiceWorker.tsx so it can be imported without pulling in mockServiceWorker.tsx's
// `import.meta.env` usage, which ts-jest can't transform.
//
// isActive is only ever flipped true via mockServiceWorker.tsx's start()/initialize(), which gate on
// isMockingAvailable() (Local/Development environments only) before calling setDemoModeActive(true). This
// module deliberately exposes no other way to set the flag, so it can't be tricked into activating by
// writing directly to the demoModeActive localStorage key in an environment where mocking isn't available.
export const DEMO_MODE_ACTIVE_STORAGE_KEY = 'demoModeActive';

let isActive = false;

export const isDemoModeActive = () => isActive;

export const setDemoModeActive = (value: boolean) => {
    isActive = value;
};
